import { useEffect, useRef } from 'react';
import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';
import { CLUSTER } from '../../../constants';
import {
  createArtifactShareFields,
  createWidgetShareFields
} from '../../GroupChat/helpers/createShareFields';

function BFPContentObject(props) {
  const {
    content,
    contentObjectId,
    messageId,
    openShare,
    ownerProfile,
    pageType,
    renderKitUrl,
    shareToGroup,
  } = props;
  const bfp = content.bfp;

  // initial server HTML for body
  const serverRender = bfp?.renders?.oo_web;

  // Any eventual page level tracking data for web cases that needs to be available
  //   within BFP can go here
  const sharedTrackingData = {
    destination: 'island',
    page_edition: 'en-us',
    ...(pageType === 'groupChat' && messageId ? {
      unit_type: 'message',
      unit_name: messageId,
    } : {}),
  };

  const bfpRef = useRef(null);

  useEffect(() => {
    loadBfpClient();
  }, []);

  const loadBfpClient = async () => {
    let urlToLoad = renderKitUrl;

    if (!urlToLoad) {
      const defaultRenderKit = content?.bfp?.render_kit?.find((kit) => {
        return kit?.url?.includes('render_kit.'); // web render kit
      });
      if (defaultRenderKit) {
        urlToLoad = defaultRenderKit?.url;
      }
    }

    if (urlToLoad) {
      await loadScript(urlToLoad);

      const formatName = bfp.format_name;
      if (bfpRef?.current && window[`bfp_${formatName}`]) {
        try {
          window[`bfp_${formatName}`].init({
            element: bfpRef.current,
            config: {
              data: bfp.data,
              context: {
                env: CLUSTER,
                clientEventTracking: sharedTrackingData,
                consumer: 'bf_island_ui',
                contentObjectId,
                contentObject: { content, id: contentObjectId, ownerProfile },
                pageType: pageType || 'unknown',
                bfpId: bfp.id,
                functions: {
                  createArtifactShareFields,
                  createWidgetShareFields,
                  openShare,
                  shareToGroup,
                },
              },
            },
            broadcast: () => {},
          });
        } catch (e) {
          console.error(`Unable to load BFP - ${e.message}`);
        }
      }
    }
  };

  return (
    <div data-name="bfp-wrapper" className="bfp-wrapper">
      {/**
       * Consistent JSON script with tracking data that individual BFPs can access
       * for contextual information about the specific location on page for CET tracking.
       * If using this component on the page, make sure to always provide this tracking info
       */}
      <script
        data-name="tracking-data"
        type="application/json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(sharedTrackingData) }}
      />
      <div ref={bfpRef} className="bfp-content">
        {serverRender && (
          <div dangerouslySetInnerHTML={{ __html: serverRender }} />
        )}
      </div>
    </div>
  );
}

export default BFPContentObject;
